module.exports = __webpack_public_path__ + "static/7-a2933ec691aaf5a9261d846d275ba9ad.jpg";